import "./blog-topics.css";

export default function BlogTopics() {
  const topics = [
    "Web Development",
    "Cloud & DevOps",
    "UI/UX Design",
    "Mobile Apps",
    "Startups",
    "Enterprise Software",
  ];

  return (
    <section className="oglitz-blog-topics">
      <div className="oglitz-blog-topics__container">
        <h2 className="oglitz-blog-topics__title">Explore Topics</h2>

        <div className="oglitz-blog-topics__list">
          {topics.map((topic) => (
            <span key={topic} className="oglitz-blog-topics__item">
              {topic}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
